import Profile from "_c/modules/profile/common/profile";
import { connect } from "react-redux";
import { Selectors } from "@/store/clientProfile/selectors";
import { Effects as UserEffects } from "@/store/user/effects";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { Actions as ModalActions } from "@/store/modals/slice";
import { Effects as FavEffects } from "@/store/favorites/effects";
import { Effects as MessengerEffects } from "@/store/messenger/effects";

const mSp = (state) => ({
  isAuth: AuthSelectors.isAuth(state),
  avatar: Selectors.getAvatar(state),
  sex: Selectors.getSex(state),
  isOwner: Selectors.isOwner(state),
  isFavorite: Selectors.isFavorite(state),
  isOnline: Selectors.isOnline(state),
  name: Selectors.getFullName(state),
  //isPremium: Selectors.isPremium(state),
  bio: Selectors.getBio(state),
  //address: Selectors.getHrAddress(state),
  favId: Selectors.getId(state),
  favType: "users",
  idForMessenger: Selectors.getId(state),
  shareId: Selectors.getId(state),
});

const mDp = {
  updateAvatar: UserEffects.updateAvatar,
  openShareModal: ModalActions.openShare,
  openAuthModal: ModalActions.openAuth,
  toggleFavorite: FavEffects.toggleFavorite,
  sendMessage: MessengerEffects.createMessageOutsideMessenger,
};

export default connect(mSp, mDp)(Profile);
